import { Component, OnInit } from '@angular/core';
import { LocalStorageHelpers } from 'app/helpers';

@Component({
  selector: 'app-header',
  templateUrl: './app-header.component.html'
})
export class AppHeaderComponent implements OnInit {
  public operator: any = {};

  constructor(
    private localStorage: LocalStorageHelpers
  ) { }

  ngOnInit() {
    this.operator = JSON.parse(this.localStorage.get('userData'));
  }
}
